<div *ngIf="header && header.lightHeader === false">
  <div
    class="idp-header-container idp-header-container--dark fixed-top bg-dark"
  >
    <div class="container idp-header">
      <div class="idp-header--primary">
        <div class="idp-header__logo">
          <ng-container
            *ngIf="header.profile === 'personal'; then personal; else business"
          ></ng-container>
          <ng-template #personal>
            <a
              [href]="header.logo.mainLogoUrl"
              [target]="
                header.logo.mainLogoNewTab !== 'true' ? '_self' : '_blank'
              "
            >
              <img
                [alt]="header.logo.mainLogoAltText"
                [src]="header.logo.mainLogo"
                class="idp-header__logo--size"
              />
            </a>
            <a
              [href]="header.logo.subLogoUrl"
              [target]="
                header.logo.subLogoNewTab !== 'true' ? '_self' : '_blank'
              "
            >
              <img
                [alt]="header.logo.subLogoAltText"
                [src]="header.logo.subLogo"
                class="ml-2"
              />
            </a>
            <div class="idp-header__logo--slim">
              <a
                [href]="header.logo.slimheaderLogoUrl"
                [target]="
                  header.logo.slimheaderLogoNewTab !== 'true'
                    ? '_self'
                    : '_blank'
                "
              >
                <img
                  [alt]="header.logo.slimheaderLogoAltText"
                  [src]="header.logo.slimheaderLogo"
                />
              </a>
            </div>
          </ng-template>

          <ng-template #business>
            <a
              [href]="header.logo.busiLogoUrl"
              [target]="
                header.logo.busiLogoNewTab !== 'true' ? '_self' : '_blank'
              "
            >
              <img
                [alt]="header.logo.busiLogoAltText"
                [src]="header.logo.busiLogo"
                class="idp-header__logo--size"
              />
            </a>
            <div class="idp-header__logo--slim">
              <a
                [href]="header.logo.slimheaderLogoUrl"
                [target]="
                  header.logo.slimheaderLogoNewTab !== 'true'
                    ? '_self'
                    : '_blank'
                "
              >
                <img
                  [alt]="header.logo.slimheaderLogoAltText"
                  [src]="header.logo.slimheaderLogo"
                />
              </a>
            </div>
          </ng-template>
        </div>

        <span class="idp-header__title">
          {{ header.title }}
        </span>
      </div>
    </div>
  </div>
</div>
<!-- Light Header with only Delta Logo and SkyTeam -->
<div *ngIf="header && header.lightHeader === true">
  <div
    class="idp-header-container idp-header-container--dark fixed-top bg-dark"
  >
    <div class="container idp-light-header">
      <div class="idp-header--primary">
        <div class="idp-light-header__logo">
          <a
            [href]="header.logo.mainLogoUrl"
            [target]="
              header.logo.mainLogoNewTab !== 'true' ? '_self' : '_blank'
            "
          >
            <img
              [alt]="header.logo.mainLogoAltText"
              [src]="header.logo.mainLogo"
              class="idp-header__logo--size"
            />
          </a>
          <a
            [href]="header.logo.subLogoUrl"
            [target]="header.logo.subLogoNewTab !== 'true' ? '_self' : '_blank'"
          >
            <img
              [alt]="header.logo.subLogoAltText"
              [src]="header.logo.subLogo"
              class="ml-2"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
